// Navigation data separated for better maintainability
export const navigationItems = [
  { title: "Home", href: "/", description: "Return to home page" },
  {
    title: "Business Tools",
    description: "Management and strategy tools",
    items: [
      {
        title: "Marketing Strategy",
        href: "/marketing-strategy",
        description: "Comprehensive marketing strategies and insights",
        icon: "📊",
      },
      {
        title: "Marketing Calendar",
        href: "/marketing-calendar",
        description: "Plan and manage marketing campaigns and events",
        icon: "📅",
      },
      {
        title: "Marketing Dashboard",
        href: "/marketing-dashboard",
        description: "Track marketing performance and campaign metrics",
        icon: "📈",
      },
      {
        title: "High ROI Campaigns",
        href: "/high-roi-campaigns",
        description: "Data-driven campaign strategies",
        icon: "💰",
      },
    ],
  },
  {
    title: "Services",
    description: "Complete pest management solutions",
    items: [
      {
        title: "Residential Services",
        href: "/residential-services",
        description: "Protecting homes and families",
        icon: "🏠",
        features: [
          "Same-day service",
          "Pet & child safe",
          "6-month guarantee",
          "24/7 emergency",
        ],
        price: "From £89",
      },
      {
        title: "Commercial Solutions",
        href: "/commercial-solutions",
        description: "Business pest management programs",
        icon: "🏢",
        features: [
          "Food safety certified",
          "Scheduled visits",
          "Documentation",
          "Staff training",
        ],
        price: "Custom quotes",
      },
      {
        title: "Industrial Solutions",
        href: "/industrial-solutions",
        description: "Large-scale facility pest management",
        icon: "🏭",
        features: [
          "Advanced technology",
          "Smart monitoring",
          "AI analytics",
          "24/7 support",
        ],
        price: "From £449/month",
      },
      {
        title: "Emergency Response",
        href: "/emergency-pest-control",
        description: "24/7 urgent pest control",
        icon: "🚨",
        features: [
          "Same-day response",
          "Out of hours",
          "Weekend service",
          "Rapid treatment",
        ],
        price: "From £149",
      },
      {
        title: "Hygiene Services",
        href: "/hygiene-services",
        description: "Professional hygiene and sanitization solutions",
        icon: "✨",
        features: [
          "Deep cleaning",
          "Air quality management",
          "Washroom solutions",
          "Surface protection",
        ],
        price: "From £199",
      },
      {
        title: "Specialist Services",
        href: "/specialist-services",
        description: "Expert solutions for unique pest challenges",
        icon: "🎯",
        features: [
          "Bird control",
          "Wasp removal",
          "Bed bugs",
          "Wildlife management",
        ],
        price: "From £129",
      },
      {
        title: "Eco-Friendly Solutions",
        href: "/eco-recommendation-engine",
        description: "Sustainable & environmentally safe treatments",
        icon: "🌿",
        features: [
          "Chemical-free options",
          "Organic treatments",
          "Green certification",
          "Eco-warrior program",
        ],
        price: "From £99",
      },
    ],
  },
  {
    title: "Specialist Solutions",
    description: "Expert services & protection programs",
    items: [
      {
        title: "Bird Control",
        href: "/specialist-services#bird-control",
        icon: "🦅",
        description: "Humane bird deterrent solutions",
      },
      {
        title: "Wasp Nest Removal",
        href: "/specialist-services#wasp-nest",
        icon: "🐝",
        description: "Safe professional wasp control",
      },
      {
        title: "Bed Bug Treatment",
        href: "/specialist-services#bed-bugs",
        icon: "🛏️",
        description: "Complete bed bug elimination",
      },
      {
        title: "Rodent Proofing",
        href: "/specialist-services#rodent-proofing",
        icon: "🏠",
        description: "Long-term rodent exclusion",
      },
      {
        title: "Integrated Pest Management",
        href: "/integrated-pest-management",
        description: "Comprehensive pest management solutions",
        icon: "🌿",
        features: [
          "Prevention-focused",
          "AI-driven analytics",
          "Eco-friendly control",
          "Long-term monitoring",
        ],
        price: "From £149",
      },
      {
        title: "Pest Protection Plans",
        href: "/pest-protection-plans",
        description: "Comprehensive protection plan services",
        icon: "🛡️",
        features: [
          "Tailored solutions",
          "Proactive monitoring",
          "Regulatory compliance",
          "Advanced technology",
        ],
        price: "From £89",
      },
      {
        title: "Aftercare Services",
        href: "/aftercare-services",
        description: "Long-term maintenance and support",
        icon: "💚",
        features: [
          "Tailored maintenance",
          "Proactive prevention",
          "Advanced monitoring",
          "Eco-friendly solutions",
        ],
        price: "From £99",
      },
      {
        title: "Quality Assurance",
        href: "/quality-assurance",
        description: "Professional QA services and audits",
        icon: "✅",
        features: [
          "Service standardisation",
          "IPM audits",
          "Technology-driven QA",
          "Continuous improvement",
        ],
        price: "Custom pricing",
      },
    ],
  },
  {
    title: "Smart Technology",
    description: "AI-powered pest management solutions",
    items: [
      {
        title: "AI Intelligence Hub",
        href: "/ai-intelligence",
        icon: "🧠",
        description:
          "Complete AI-powered pest management dashboard with chatbot",
      },
      {
        title: "Smart Pest Sensors",
        href: "/iot-pest-sensors",
        icon: "📡",
        description: "24/7 automated monitoring",
      },
      {
        title: "AR Pest Detection",
        href: "/ar-pest-identification",
        icon: "📱",
        description: "AI-powered pest identification",
      },
      {
        title: "Smart Alerts System",
        href: "/smart-pest-alerts",
        icon: "🔔",
        description: "Real-time notifications",
      },
      {
        title: "Predictive Analytics",
        href: "/predictive-calendar",
        icon: "🧠",
        description: "AI-driven pest forecasting",
      },
      {
        title: "Pest Trends Dashboard",
        href: "/pest-trends-dashboard",
        icon: "📊",
        description: "AI-powered trend analysis and insights",
      },
      {
        title: "AI Prevention Sidekick",
        href: "/ai-prevention-sidekick",
        icon: "🤖",
        description: "Personalized prevention assistant",
      },
      {
        title: "Seasonal Prevention Calendar",
        href: "/seasonal-prevention-calendar",
        icon: "📅",
        description: "Personalized monthly prevention schedules",
      },
    ],
  },
  {
    title: "Pricing",
    href: "/pricing",
    description: "Transparent pricing plans and calculator",
  },
  {
    title: "Security",
    href: "/security",
    description: "Enterprise security and compliance",
  },
  {
    title: "Enterprise",
    href: "/enterprise",
    description: "Enterprise solutions and procurement",
  },
];
